import { render, staticRenderFns } from "./TaxesPaymentSection.vue?vue&type=template&id=09f584b2&scoped=true"
import script from "./TaxesPaymentSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxesPaymentSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TaxesPaymentSection.vue?vue&type=style&index=0&id=09f584b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f584b2",
  null
  
)

export default component.exports